import '../ProductManagememt/style.css';
import IMG from "../../constants/image";
import React from "react";
import Button from "../Common/Button";
import {PATH, VARIANT} from "../../constants";
import {Link, useNavigate} from "react-router-dom";

const EmptyProduct = () => {
	const navigate = useNavigate();
	
	return (
		<div
			className='w-fit mx-auto flex flex-col p-4 justify-center items-center md:px-[70px] md:py-[50px] gap-10 mt-8'
		>
			<img className='w-[194px] h-[135px]' src={IMG.emptyProduct} alt="emptyProduct"/>
			<p className='text-center text-sm'>
				Bạn chưa có sản phẩm nào trong cửa hàng.<br/>
				Tạo sản phẩm của bạn ngay để bắt đầu bán hàng nhé
			</p>
			<Link className='cursor-pointer' to={PATH.CREATE_PRODUCT}>
				<Button className='md:w-[364px]' variant={VARIANT.PRIMARY} onClick={()=>navigate(PATH.CREATE_PRODUCT)}>
					+ Tạo sản phẩm ngay
				</Button>
			</Link>
		</div>
	)
};

export default EmptyProduct;